<template>

  <div>
    <layout-vertical>
      <router-view :key="$route.fullPath"/>

      <!--<app-customizer-->
      <!--v-if="showCustomizer"-->
      <!--slot="customizer"-->
      <!--/>-->

    </layout-vertical>
  </div>


</template>

<script>
import LayoutVertical from "@core/layouts/layout-vertical/LayoutVertical.vue"
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import {$themeConfig} from "@themeConfig"

export default {
  components: {
    LayoutVertical,
    // AppCustomizer,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>